<script>
    import StarRating from 'vue-star-rating';

    export default {
        props: [
            'courseprop',
            'total_score_prop',
            'reviewprop',
        ],
        components: {StarRating},
        data() {
            return {
                course: null,
                total_score: null,
                review: {
                    helpful_counter: null
                }
            }
        },
        mounted() {
            this.course = this.courseprop;
            this.total_score = this.total_score_prop;
            this.review = this.reviewprop;
        },
        methods: {
            getReviewId(review) {
                return '#notifyReviewModal' + review.id
            },
            getReviewModalId(review) {
                return 'notifyReviewModal' + review.id
            },
            getFirstRadioId(review) {
                return '#notifyReviewFirstRadio' + review.id
            },
            getSecondRadioId(review) {
                return '#notifyReviewSecondRadio' + review.id
            },
            updateCounter() {
                var self = this;
                axios({
                    method: 'post',
                    url: '/review/' + self.review.id + '/counter',
                    data: {
                        review: self.review
                    },
                }).then((response) => {
                    self.review.helpful_counter += 1;
                }).catch((error) => {
                });
            }
        },

        watch: {
            counter: {
                handler: function () {

                },
                deep: true,
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/course/CourseReviewItem.vue